<template functional>
  <component
    :is="injections.components.VueContentLoading"
    :primary="parent.$scss.colors.cardBg"
    :secondary="parent.$scss.colors.inputBg"
    :height="98"
  >
    <rect x="0" y="0" rx="4" ry="4" width="400" height="98"></rect>
  </component>
</template>

<script>
import VueContentLoading from 'vue-content-loading';

export default {
  name: 'ParticipantUserCardLoader',
  inject: {
    components: {
      default: {
        VueContentLoading,
      },
    },
  },
};
</script>
